import React from 'react';
import '../styles/ErrorPage.css';
import { reportError } from '../services/errorReporter';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      // Keep details in development only.
      // eslint-disable-next-line no-console
      console.error('Unhandled application error:', error, errorInfo);
    }
    // Report to backend → CloudWatch in all environments
    reportError(
      error?.message || String(error),
      error?.stack || null,
      window.location.href,
    );
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="error-page" role="main">
        <section className="error-card" aria-live="assertive">
          <p className="error-kicker">AirFlyNow</p>
          <h1 className="error-title">Something went wrong</h1>
          <p className="error-message">
            We hit an unexpected issue. Please refresh this page or go back to the home screen.
          </p>
          <div className="error-actions">
            <button type="button" className="error-btn error-btn--primary" onClick={this.handleReload}>
              Refresh page
            </button>
            <a href="/" className="error-btn error-btn--secondary">
              Go to Home
            </a>
          </div>
        </section>
      </main>
    );
  }
}

export default ErrorBoundary;
